import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import ukDataSet from 'libraries/locales/uk.json'
import russianDataSet from 'libraries/locales/ru.json'
import englishDataSet from 'libraries/locales/en.json'

i18n
  .use(LanguageDetector) // detect user language , learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(initReactI18next) // pass the i18n instance to react-i18next
  .init({
    lng: localStorage.getItem('i18nextLng') ?? 'uk',
    resources: {
      uk: {
        translation: ukDataSet,
      },
      ru: {
        translation: russianDataSet,
      },
      en: {
        translation: englishDataSet,
      },
    },
  })

export default i18n
